var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutOfHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Table-Restaurant--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Table Restaurant Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.75a2 2 0 0 0 -2 -2H3.2a0.25 0.25 0 0 1 -0.2 -0.24c0 -0.63 -0.08 -1.26 -0.17 -1.89L2 4.11a1 1 0 0 0 -2 0.28l0.8 5.52a21.08 21.08 0 0 1 -0.32 7.56L0 19.53a1 1 0 0 0 0.76 1.2l0.22 0A1 1 0 0 0 2 20l0.45 -2.06A23.53 23.53 0 0 0 3 14a0.25 0.25 0 0 1 0.25 -0.24h3a0.25 0.25 0 0 1 0.25 0.24v5.75a1 1 0 0 0 2 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 19.75a1 1 0 0 0 -1 -1 0.5 0.5 0 0 1 -0.5 -0.5v-7.5a0.5 0.5 0 0 1 0.5 -0.5H18a1 1 0 0 0 0 -2H6a1 1 0 0 0 0 2h4.5a0.5 0.5 0 0 1 0.5 0.5v7.5a0.5 0.5 0 0 1 -0.5 0.5 1 1 0 0 0 0 2h3a1 1 0 0 0 1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.52 17.47a21.31 21.31 0 0 1 -0.32 -7.56l0.8 -5.52a1 1 0 0 0 -2 -0.28l-0.79 5.51c-0.09 0.63 -0.14 1.26 -0.17 1.89a0.25 0.25 0 0 1 -0.25 0.24H17.5a2 2 0 0 0 -2 2v6a1 1 0 0 0 2 0V14a0.25 0.25 0 0 1 0.25 -0.25h3A0.25 0.25 0 0 1 21 14a23.53 23.53 0 0 0 0.53 3.92L22 20a1 1 0 0 0 1 0.78l0.22 0a1 1 0 0 0 0.76 -1.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutOfHome);
export default ForwardRef;